export default "__VITE_ASSET__xe0H2xjo__"